import { computed, getCurrentInstance } from "@vue/composition-api";

export default function useBreakPoints() {
  const vm = getCurrentInstance();

  const isMobile = computed(() => vm && vm.$screen.mobile && !vm.$screen.tablet);
  const portraitUp = computed(() => vm && vm.$screen.portraitBP);
  const tabletUp = computed(() => vm && vm.$screen.tablet);
  const landscapeUp = computed(() => vm && vm.$screen.landscapeBP);
  const desktopUp = computed(() => vm && vm.$screen.desktop);

  return {
    isMobile,
    portraitUp,
    tabletUp,
    landscapeUp,
    desktopUp,
  };
}
